module.exports = __webpack_public_path__ + "media/calendar-app-demo-exc-4aeae83c23314ba59fe469ed9cfbb812.mp4";